export default __webpack_public_path__ + "static/media/bg_table.c2211517.png";